// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

import get from 'lodash/get';

import calculateRequestPath, { splitPathAndQueryString } from 'api/calculate-resource-request-path';

import { type ClientsType } from 'types/clients';
import { type EngagementsType } from 'types/engagements';
import { type SubjectsType } from 'types/subjects';

import { getResource } from 'actions/resources/thunks';
import { type StateType as ReducerStateType } from 'reducers';

import SessionsCreateForm from 'containers/sessions/create/form';

import Wrapper from 'components/shared/wrapper';
import Loader from 'components/loader';

//

const requestArgs = {
  resource: 'tutoringEngagements',
  includes: ['client', 'subject'],
  isTutor: true,
};

// ENHANCE

type PropsFromStateType = {
  flash: boolean,
  tutoringEngagements: EngagementsType,
  subjects: SubjectsType,
  clients: ClientsType,
  pageReady: boolean,
};

const mapStateToProps = ({
  application: { flash },
  resources: { tutoringEngagements, clients, subjects, meta },
}: ReducerStateType): PropsFromStateType => {
  const requestPath = calculateRequestPath(requestArgs);
  const requestMeta = get(meta, splitPathAndQueryString(requestPath));
  const pageReady = !!requestMeta;

  return {
    clients,
    flash,
    subjects,
    tutoringEngagements,
    pageReady,
  };
};

type DispatchPropsType = {
  dispatchGetResource: typeof getResource,
};

const mapDispatchToProps: DispatchPropsType = {
  dispatchGetResource: getResource,
};

type PropsType = PropsFromStateType & DispatchPropsType;

class CreateSessionForm extends Component<PropsType> {
  componentDidMount() {
    const { dispatchGetResource } = this.props;
    dispatchGetResource(requestArgs);
  }

  render() {
    const { flash, tutoringEngagements, subjects, clients, pageReady } = this.props;

    return (
      <Wrapper hasBackground hasFlash={!!flash}>
        {pageReady ? (
          <SessionsCreateForm
            engagements={tutoringEngagements}
            subjects={subjects}
            clients={clients}
          />
        ) : (
          <Loader />
        )}
      </Wrapper>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateSessionForm);



// WEBPACK FOOTER //
// ./src/screens/sessions/create/index.js